var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/stack/stack.tsx";
const _excluded = ["space", "alignItems", "justifyContent", "className", "grow"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import classNames from 'classnames';
import React from 'react';
const spaces = {
  0: 'space-y-0',
  '0.5': 'space-y-0.5',
  1: 'space-y-1',
  '1.5': 'space-y-1.5',
  2: 'space-y-2',
  3: 'space-y-3',
  4: 'space-y-4',
  5: 'space-y-5',
  10: 'space-y-10'
};
const justifyContentOptions = {
  center: 'justify-center'
};
const alignItemsOptions = {
  center: 'items-center'
};
/** Vertical stack of child elements. */
const Stack = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      space,
      alignItems,
      justifyContent,
      className,
      grow
    } = props,
    filteredProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, filteredProps, {
    ref: ref,
    className: classNames('flex flex-col', {
      // @ts-ignore
      [spaces[space]]: typeof space !== 'undefined',
      // @ts-ignore
      [alignItemsOptions[alignItems]]: typeof alignItems !== 'undefined',
      // @ts-ignore
      [justifyContentOptions[justifyContent]]: typeof justifyContent !== 'undefined',
      'flex-grow': grow
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }));
});
export default Stack;